import { Box, Image } from '@domain-group/suit-theme'

import type { ImageModel } from '@models/types'

interface ImageTileProps {
  callbacks: { handleClick: () => void },
  image: ImageModel,
  isSelected: boolean,
}

const ImageTile = (props: ImageTileProps) => {
  const { callbacks: { handleClick }, image, isSelected } = props

  return (
    <Box
      borderRadius="5px"
      onClick={() => handleClick()}
    >
      <Image
        borderRadius="5px"
        key={image.id}
        style={{ cursor: 'pointer' }}
        url={image.thumb_url}
      >
        {!isSelected && (
          <Box
            backgroundColor="rgba(255, 255, 255, 0.7)"
            zIndex="5"
            height="100%"
            width="100%"
          />
        )}
      </Image>
    </Box>
  )
}

export default ImageTile
